import { render, staticRenderFns } from "./SupportDialogBtn.vue?vue&type=template&id=6a38c955&"
import script from "./SupportDialogBtn.vue?vue&type=script&lang=ts&"
export * from "./SupportDialogBtn.vue?vue&type=script&lang=ts&"
import style0 from "./SupportDialogBtn.vue?vue&type=style&index=0&id=6a38c955&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports